<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    size?: string;
    tag?: string;
  }>(),
  {
    size: "text-3.75",
    tag: "p",
  },
);

const textSizeClass = computed(() => `${toRef(props, "size").value}`);
</script>

<template>
  <component :is="tag" :class="textSizeClass">
    <slot name="default" />
  </component>
</template>
